import React, { useEffect, useRef } from "react";
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CFormLabel,
  CFormTextarea,
  CRow,
  CFormSelect,
} from "@coreui/react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Select from "react-select";
import { useState, useMemo } from "react";
import countryList from "react-select-country-list";
import { NotificationManager } from "react-notifications";
//import { getMaster } from "src/modules/subscriptionAdmin/action";
import { getAllCompanies } from "src/modules/company/action";
import { useDispatch } from "react-redux";
import validator from "validator";
// List of countries
const allData = require("country-currency-list");
import CIcon from "@coreui/icons-react";
import { cilPlus, cilTrash } from "@coreui/icons";
import { generateCoupon } from "src/modules/coupon/action";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Country } from "country-state-city";
const countryOption = Country.getAllCountries();
const getOptionLabel = (option) => option.phonecode;
const getOptionValue = (option) => option.phonecode;
let companiesOptions = [];
var isoCountryCurrency = require("iso-country-currency");
const currentDate = new Date();
const moduleOptions = [{name:"DOCTOR_BOOKING",value:"DOCTOR_BOOKING",label:"Video Consultation"}]
class CreateBundle extends React.Component {
  constructor() {
    super();
    this.state = {
      company: "",
      currency: "",
      companyCode: "",
      countryCode: "",
      companyId: "",
      count: 1,
      module: 'DOCTOR_BOOKING',
      couponValue: "100",
      valueType: "PERCENT",
      startDate: new Date(),
      showCouponValue: true,
      endDate: new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate() + 30
      ),
      companies: [],
      companyName: "",
      userId: "",
      transactionReference: "",
      terminalId: "",
      emailId: "",
      contact: "",
      paymentType: "",
      cardType: "",
      transactionDate: new Date(),
      couponType: "single",
      phoneCode: "",
      countryItem: {
        phonecode: "855",
      },
      currentCountry: "",
      packages: "pro",
      loading: false,
      usage: "unlimited",
      limit: "",
      startDateChanged: false,
      upa: false,
    };
  }
  handleModuleChange = (e) => {
    const selectedModule = e.target.value;
    this.setState({ module: selectedModule }, () => {
      console.log(this.state.module);
    });
  };
  handleStartDateChanged = (date) => {
    this.setState({ startDateChanged: true, startDate: date });
  };
  componentDidUpdate(prevProps) {
    const { data, createBundleSuccess, companyList } = this.props;
    const {
      data: prevData,
      createBundleSuccess: prevCreateBundleSuccess,
      companyList: prevCompanyList,
    } = prevProps;
    if (companyList && companyList !== prevCompanyList) {
      const companiesOptions =
        companyList.companies &&
        companyList.companies.map((company) => ({
          value: company._id,
          label: company.companyName + "(" + company.country + ")",
          name: company.companyName,
          country: company.country,
          companyCode: company.companyCode,
          countryCode: company.countryCode,
          companyId: company._id,
        }));
      const currency = isoCountryCurrency.getParamByParam(
        "countryName",
        companyList.companies[0] ? companyList.companies[0].country : "",
        "currency"
      );
      this.setState({
        companies: companiesOptions,
        currency: currency,
      });
    }
    // create success
    if (
      createBundleSuccess &&
      createBundleSuccess !== prevCreateBundleSuccess
    ) {
      this.setState({
        loading: false,
      });
      NotificationManager.success("Bundle Created");
      this.setState({
        company: "",
        currency: "",
        companyCode: "",
        countryCode: "",
        companyId: "",
        count: "",
        module: "",
        couponValue: "",
        valueType: "",
        startDate: "",
        endDate: "",
        companyName: "",
      });
      this.props.history.push("/admin/bundle/list");
    }
  }
  cancelForm = (e) => {
    e.preventDefault();
    this.props.history.goBack();
  };
  componentDidMount() {
    const id = localStorage.getItem("USERID");
    this.setState({
      userId: id,
    });
    this.props.getAllCompanies();
  }
  convertToMillisecond = (data) => {
    const dateObj = new Date(data);
    const milliseconds = dateObj.getTime();
    return milliseconds;
  };
  handleSubmit = (event) => {
    event.preventDefault();
    const {
      company,
      companyName,
      currency,
      companyCode,
      countryCode,
      companyId,
      count,
      module,
      couponValue,
      valueType,
      startDate,
      endDate,
      userId,
      transactionReference,
      terminalId,
      emailId,
      contact,
      paymentType,
      cardType,
      transactionDate,
      couponType,
      packages,
      countryItem,
      limit,
      usage,
      upa,
    } = this.state;
    if (company === null || company === "") {
      NotificationManager.error("Company Name is required");
      return false;
    }
    if (companyCode === null || companyCode === "") {
      NotificationManager.error("Company Code is required");
      return false;
    }
    if (valueType === null || valueType === "") {
      NotificationManager.error("Value Type is required");
      return false;
    }
    if (couponValue === null || couponValue === "") {
      NotificationManager.error("Coupon Value is required");
      return false;
    } else if (valueType === "PERCENT" && couponValue > 100) {
      NotificationManager.error("Invalid Coupon Value");
      return false;
    }
    if (module == null || module == "" || module == "null") {
      this.setState({ module: "DOCTOR_BOOKING" });
    }
    const isDecimal = /^[-+]?[0-9]+\.[0-9]+$/;
    if (count == null || count == "") {
      NotificationManager.error("Count is required");
      return false;
    } else if (count <= 0) {
      NotificationManager.error("Coupon count is invalid");
      return false;
    } else if (isDecimal.test(count)) {
      NotificationManager.error("Coupon count is invalid");
      return false;
    }
    if (startDate == null || startDate == "") {
      NotificationManager.error("Start Date is required");
      return false;
    }
    if (endDate == null || endDate == "") {
      NotificationManager.error("End Date is required");
      return false;
    }

    if (couponType === "single" && emailId === "") {
      NotificationManager.error("Email is required");
      return false;
    } else if (couponType === "single" && !validator.isEmail(emailId)) {
      NotificationManager.error("Invalid Email");
      return false;
    }

    if (couponType === "single" && (packages === "" || packages === null)) {
      NotificationManager.error("Package is required");
      return false;
    }

    if (usage === "limited" && (limit === "" || limit === "0")) {
      NotificationManager.error("Limit is required");
      return false;
    }

    if (parseInt(couponValue) < 1) {
      NotificationManager.error("coupon Value must be greater then 0");
      return false;
    }

    console.log(module)

    const postData = {
      count: count,
      companyName: companyName,
      companyCode: companyCode,
      countryCode: countryCode,
      module: module,
      couponValue: couponValue,
      valueType: valueType === "WAVEOFF" ? "PERCENT" : valueType,
      startDate: this.convertToMillisecond(startDate),
      endDate: this.convertToMillisecond(endDate),
      companyId: companyId,
      createdBy: userId,
      couponType: couponType,
      transactionRef: transactionReference,
      paymentType: paymentType,
      terminalId: terminalId,
      cardType: cardType,
      email: emailId,
      phone: countryItem.phonecode + " " + contact,
      transactionTime: this.convertToMillisecond(transactionDate),
      package: packages,
      usePerAccount: upa,
    };

    console.log("postData", module);

    if (couponType === "single") {
      postData.limit = usage === "limited" ? limit : "99999";
      postData.type = usage;
    }
    this.props.generateCoupon({ postData });
    this.setState({ loading: true });
    // this.setState({ module: "" });
  };
  handleValueType = (e) => {
    if (e.target.value === "WAVEOFF") {
      this.setState({
        couponValue: "100",
      });
    } else {
      this.setState({
        couponValue: "",
      });
    }
    this.setState({
      valueType: e.target.value,
      showCouponValue: true,
    });
  };
  handlePackage = (e) => {
    this.setState({
      packages: e.target.value,
    });
  };
  handleCompanyChange = (selectedOption) => {
    const currency = isoCountryCurrency.getParamByParam(
      "countryName",
      selectedOption.country,
      "currency"
    );
    this.setState({
      currency: currency,
      companyCode: selectedOption.companyCode,
      companyId: selectedOption.companyId,
      countryCode: selectedOption.countryCode,
      companyName: selectedOption.name,
      company: {
        label: selectedOption.label,
        value: selectedOption.value,
      },
    });
  };

  // change coupon type
  changeCouponType = (e) => {
    e.preventDefault();
    this.setState({
      couponType: e.target.value,
    });
  };

  handleChangePhoneCode = (value) => {
    this.setState((prevState) => ({
      countryItem: {
        ...prevState.countryItem,
        phonecode: value.phonecode,
      },
    }));
    this.setState({
      //phoneCode: value.phonecode,
      countryItem: value,
    });
  };

  render() {
    const {
      company,
      currency,
      companyCode,
      countryCode,
      companyId,
      count,
      module,
      couponValue,
      valueType,
      startDate,
      endDate,
      showCouponValue,
      companies,
      transactionReference,
      terminalId,
      emailId,
      contact,
      paymentType,
      cardType,
      transactionDate,
      couponType,
      phoneCode,
      countryItem,
      packages,
      loading,
      usage,
      limit,
      upa,
      startDateChanged,
    } = this.state;
    const START_DATE = new Date(Date.parse(startDate));
    const minDate = new Date(START_DATE);
    minDate.setDate(START_DATE.getDate() + 1);
    return (
      <>
        <CCard>
          <CCardBody>
            <CForm
              className='form-horizontal'
              noValidate
              //onSubmit={this.state.button === "ADD" ? this.add : this.update}
              onSubmit={!loading ? this.handleSubmit : ""}
            >
              <CRow>
                <CCol xs={6}>
                  <CRow>
                    <CCol md={12}>
                      <div className='mb-3'>
                        <CFormLabel htmlFor='exampleFormControlInput1'>
                          <strong>Type </strong>
                        </CFormLabel>
                        <select
                          value={couponType}
                          onChange={this.changeCouponType}
                          className='form-control'
                        >
                          <option value='single' selected>
                            Single
                          </option>
                          <option value='bundle'>Bundle</option>
                        </select>
                      </div>
                      <div className='mb-3'>
                        <CFormLabel htmlFor='exampleFormControlInput1'>
                          <strong>Company </strong>
                          <span className='required'>*</span>
                        </CFormLabel>
                        <Select
                          value={company}
                          onChange={this.handleCompanyChange}
                          options={companies}
                          placeholder='Select Company'
                        />
                      </div>
                      <div className='mb-3'>
                        <CRow>
                          <CCol md={4}>
                            <CFormLabel htmlFor='exampleFormControlInput1'>
                              <strong>Value Type </strong>
                              <span className='required'>*</span>
                            </CFormLabel>
                            <div className='form-check'>
                              <input
                                className='form-check-input'
                                type='radio'
                                value='PRICE'
                                id='flexCheckDefault'
                                name='value_type'
                                onChange={this.handleValueType}
                                checked={valueType === "PRICE" ? true : false}
                              />
                              <label
                                className='form-check-label'
                                for='flexCheckDefault'
                              >
                                AMOUNT
                              </label>
                            </div>
                            <div className='form-check'>
                              <input
                                className='form-check-input'
                                type='radio'
                                value='PERCENT'
                                id='flexCheckDefault'
                                name='value_type'
                                onChange={this.handleValueType}
                                checked={valueType === "PERCENT" ? true : false}
                              />
                              <label
                                className='form-check-label'
                                for='flexCheckDefault'
                              >
                                PERCENT
                              </label>
                            </div>
                            <div className='form-check'>
                              <input
                                className='form-check-input'
                                type='radio'
                                value='WAVEOFF'
                                id='flexCheckDefault'
                                name='value_type'
                                onChange={this.handleValueType}
                                checked={couponValue === "100" ? true : false}
                              />
                              <label
                                className='form-check-label'
                                for='flexCheckDefault'
                              >
                                WAIVE OFF
                              </label>
                            </div>
                            {/* flat  */}
                            <div className='form-check'>
                              <input
                                className='form-check-input'
                                type='radio'
                                value='FIXED'
                                id='flexCheckDefault'
                                name='value_type'
                                onChange={this.handleValueType}
                                checked={valueType === "FIXED" ? true : false}
                              />
                              <label
                                className='form-check-label'
                                for='flexCheckDefault'
                              >
                                FIXED
                              </label>
                            </div>
                          </CCol>
                          <CCol md={8}>
                            {showCouponValue && (
                              <div className='mb-3'>
                                {valueType == "PRICE" && (
                                  <>
                                    <CFormLabel htmlFor='exampleFormControlTextarea1'>
                                      <strong>Coupon Value </strong>
                                      <span className='required'>*</span>
                                    </CFormLabel>
                                    <CRow>
                                      <CCol md={4}>
                                        <CFormInput
                                          type='text'
                                          id='exampleFormControlInput1'
                                          value={currency}
                                          placeholder='Currency'
                                          onChange={(e) =>
                                            this.setState({
                                              couponValue: e.target.value,
                                            })
                                          }
                                          readOnly
                                        />
                                      </CCol>
                                      <CCol md={8}>
                                        <CFormInput
                                          type='number'
                                          id='exampleFormControlInput1'
                                          value={couponValue}
                                          placeholder='Coupon Value'
                                          onChange={(e) =>
                                            this.setState({
                                              couponValue: e.target.value,
                                            })
                                          }
                                        />
                                      </CCol>
                                    </CRow>
                                  </>
                                )}
                                {valueType == "PERCENT" && (
                                  <>
                                    <CFormLabel htmlFor='exampleFormControlTextarea1'>
                                      <strong>Discount Value </strong>
                                      <span className='required'>*</span>
                                    </CFormLabel>
                                    <CRow>
                                      <CCol md={12}>
                                        <CFormInput
                                          type='number'
                                          id='exampleFormControlInput1'
                                          value={couponValue}
                                          placeholder='Discount Value'
                                          onChange={(e) =>
                                            this.setState({
                                              couponValue: e.target.value,
                                            })
                                          }
                                        />
                                      </CCol>
                                    </CRow>
                                  </>
                                )}
                                {valueType == "WAVEOFF" && (
                                  <>
                                    <CFormLabel htmlFor='exampleFormControlTextarea1'>
                                      <strong>Discount Value </strong>
                                      <span className='required'>*</span>
                                    </CFormLabel>
                                    <CRow>
                                      <CCol md={12}>
                                        <CFormInput
                                          readOnly
                                          type='number'
                                          id='exampleFormControlInput1'
                                          value={couponValue}
                                          placeholder='Discount Value'
                                          onChange={(e) =>
                                            this.setState({
                                              couponValue: e.target.value,
                                            })
                                          }
                                        />
                                      </CCol>
                                    </CRow>
                                  </>
                                )}
                                {valueType == "FIXED" && (
                                  <>
                                    <CFormLabel htmlFor='exampleFormControlTextarea1'>
                                      <strong>Fixed Amount</strong>
                                      <span className='required'>*</span>
                                    </CFormLabel>
                                    {/* <CRow>
                                      <CCol md={12}>
                                        <CFormInput
                                          //readOnly
                                          type="number"
                                          id="exampleFormControlInput1"
                                          value={couponValue}
                                          placeholder="Fixed Amount"
                                          onChange={(e) =>
                                            this.setState({
                                              couponValue: e.target.value,
                                            })
                                          }
                                        />
                                      </CCol>
                                    </CRow> */}
                                    <CRow>
                                      <CCol md={4}>
                                        <CFormInput
                                          type='text'
                                          id='exampleFormControlInput1'
                                          value={currency}
                                          placeholder='Currency'
                                          onChange={(e) =>
                                            this.setState({
                                              couponValue: e.target.value,
                                            })
                                          }
                                          readOnly
                                        />
                                      </CCol>
                                      <CCol md={8}>
                                        <CFormInput
                                          //readOnly
                                          type='number'
                                          id='exampleFormControlInput1'
                                          value={couponValue}
                                          placeholder='Fixed Amount'
                                          onChange={(e) =>
                                            this.setState({
                                              couponValue: e.target.value,
                                            })
                                          }
                                        />
                                      </CCol>
                                    </CRow>
                                  </>
                                )}
                              </div>
                            )}
                          </CCol>
                        </CRow>
                      </div>
                      <div className='mb-3'>
                        <CRow>
                          <CCol md={4}>
                            <CFormLabel htmlFor='exampleFormControlInput1'>
                              <strong>Package </strong>
                              <span className='required'>*</span>
                            </CFormLabel>
                          </CCol>
                          <CCol md={4}>
                            <div className='form-check'>
                              <input
                                className='form-check-input'
                                type='radio'
                                value='pro'
                                id='packagePro'
                                name='packages'
                                onChange={this.handlePackage}
                                checked={packages === "pro" ? true : false}
                              />
                              <label
                                className='form-check-label'
                                for='flexCheckDefault'
                              >
                                Pro
                              </label>
                            </div>
                          </CCol>
                          <CCol md={4}>
                            <div className='form-check'>
                              <input
                                className='form-check-input'
                                type='radio'
                                value='standard'
                                id='packageStandard'
                                name='packages'
                                onChange={this.handlePackage}
                                checked={packages === "standard" ? true : false}
                              />
                              <label
                                className='form-check-label'
                                for='flexCheckDefault'
                              >
                                Standard
                              </label>
                            </div>
                          </CCol>
                        </CRow>
                      </div>
                      <div className='mb-3'>
                        <CFormLabel htmlFor='exampleFormControlInput1'>
                          <strong>Start Date </strong>
                          <span className='required'>*</span>
                        </CFormLabel>
                        <DatePicker
                          selected={startDate}
                          //onChange={(date) => this.setState({ startDate: date })}
                          onChange={(date) => this.handleStartDateChanged(date)}
                          className='form-control'
                          minDate={new Date()}
                          placeholderText='Start Date'
                          dateFormat='MM-dd-yyyy'
                        />
                      </div>
                      <div className='mb-3'>
                        <CFormLabel htmlFor='exampleFormControlInput1'>
                          <strong>End Date </strong>
                          <span className='required'>*</span>
                        </CFormLabel>
                        <DatePicker
                          selected={
                            startDateChanged
                              ? new Date(
                                  startDate.getFullYear(),
                                  startDate.getMonth(),
                                  startDate.getDate() + 30
                                )
                              : endDate
                          }
                          onChange={(date) =>
                            this.setState({
                              endDate: date,
                              startDateChanged: false,
                            })
                          }
                          className='form-control'
                          minDate={minDate}
                          initialDate={startDate}
                          //maxDate={new Date()}
                          placeholderText='End Date'
                          dateFormat='MM-dd-yyyy'
                        />
                      </div>
                      {couponType === "single" && (
                        <>
                          <div className='mb-3'>
                            <CFormLabel htmlFor='exampleFormControlInput1'>
                              <strong>Email ID </strong>
                              <span className='required'>*</span>
                            </CFormLabel>
                            <CFormInput
                              type='text'
                              id='exampleFormControlInput1'
                              value={emailId}
                              placeholder='Email ID'
                              onChange={(e) =>
                                this.setState({
                                  emailId: e.target.value,
                                })
                              }
                            />
                          </div>
                          <div>
                            <CCol md={12}>
                              <CFormLabel htmlFor='exampleFormControlInput1'>
                                <strong>Contact Number </strong>
                              </CFormLabel>
                              <CRow>
                                <CCol md={3}>
                                  <Select
                                    options={countryOption}
                                    value={countryItem}
                                    onChange={this.handleChangePhoneCode}
                                    getOptionLabel={getOptionLabel}
                                    getOptionValue={getOptionValue}
                                    placeholder='91'
                                  />
                                </CCol>
                                <CCol md={9}>
                                  <CFormInput
                                    type='text'
                                    id='exampleFormControlInput1'
                                    value={contact}
                                    placeholder='Whatsapp'
                                    onChange={(e) => {
                                      const inputValue = e.target.value;
                                      if (
                                        /^\d+$/.test(inputValue) ||
                                        inputValue === ""
                                      ) {
                                        this.setState({
                                          contact: inputValue,
                                        });
                                      }
                                    }}
                                  />
                                </CCol>
                              </CRow>
                            </CCol>
                          </div>
                        </>
                      )}
                    </CCol>
                  </CRow>
                </CCol>
                <CCol xs={6}>
                  <CRow>
                    <CCol md={12}>
                      <div className='mb-3'>
                        <CFormLabel htmlFor='exampleFormControlInput1'>
                          <strong>Company Code </strong>
                          <span className='required'>*</span>
                        </CFormLabel>
                        <CFormInput
                          type='text'
                          id='exampleFormControlInput1'
                          placeholder='Company Code'
                          onChange={(e) =>
                            this.setState({ companyCode: e.target.value })
                          }
                          value={companyCode}
                          readOnly
                        />
                      </div>
                      <div className='mb-3'>
                        <CFormLabel htmlFor='exampleFormControlInput1'>
                          <strong>Module </strong>
                          <span className='required'>*</span>
                        </CFormLabel>
                        <CFormSelect
                            onChange={this.handleModuleChange}
                            value={this.state.module}
                            aria-label='Default select example'
                        >
                            <option value='MEDICAL_TRANSPORT'>
                                Medical Transport
                            </option>
                            <option value='DOCTOR_BOOKING' selected>
                                Video Consultation
                            </option>
                        </CFormSelect>
                      </div>
                      <div className='mb-3'>
                        <CFormLabel htmlFor='exampleFormControlInput1'>
                          <strong>Count </strong>
                          <span className='required'>*</span>
                        </CFormLabel>
                        <CFormInput
                          readOnly={couponType === "single" ? true : false}
                          type='number'
                          id='exampleFormControlInput1'
                          placeholder='Enter Count'
                          onChange={(e) =>
                            this.setState({ count: e.target.value })
                          }
                          value={couponType === "single" ? 1 : count}
                        />
                      </div>
                      {/* use per account  */}
                      <div className='mb-3'>
                        <CRow>
                          <CCol md={6}>
                            <CFormLabel htmlFor='exampleFormControlInput1'>
                              <strong>Use per account ? </strong>
                              <span className='required'>*</span>
                            </CFormLabel>
                          </CCol>
                          <CCol md={3}>
                            <div className='form-check'>
                              <input
                                className='form-check-input'
                                type='radio'
                                value={true}
                                id='upaTrue'
                                name='upa'
                                onChange={() => {
                                  this.setState({ upa: true });
                                }}
                                checked={upa === true ? true : false}
                              />
                              <label
                                className='form-check-label'
                                for='flexCheckDefault'
                              >
                                True
                              </label>
                            </div>
                          </CCol>
                          <CCol md={3}>
                            <div className='form-check'>
                              <input
                                className='form-check-input'
                                type='radio'
                                value={false}
                                id='upaFalse'
                                name='upa'
                                onChange={() => {
                                  this.setState({ upa: false });
                                }}
                                checked={upa === false ? true : false}
                              />
                              <label
                                className='form-check-label'
                                for='flexCheckDefault'
                              >
                                False
                              </label>
                            </div>
                          </CCol>
                        </CRow>
                      </div>
                      {couponType === "single" && (
                        <>
                          <div className='mb-3'>
                            <CFormLabel htmlFor='exampleFormControlInput1'>
                              <strong>Payment Type </strong>
                            </CFormLabel>
                            <CFormSelect
                              value={paymentType}
                              onChange={(e) =>
                                this.setState({ paymentType: e.target.value })
                              }
                              className='form-control'
                            >
                              <option value=''>Select</option>
                              <option value='cash' selected>
                                Cash
                              </option>
                              <option value='card'>Card</option>
                            </CFormSelect>
                          </div>
                          <div className='mb-3'>
                            <CFormLabel htmlFor='exampleFormControlInput1'>
                              <strong>Card Type </strong>
                            </CFormLabel>
                            <CFormSelect
                              value={cardType}
                              onChange={(e) =>
                                this.setState({ cardType: e.target.value })
                              }
                              className='form-control'
                            >
                              <option value=''>Select</option>
                              <option value='visa'>Visa</option>
                              <option value='master'>Master</option>
                              <option value='amex'>Amex</option>
                            </CFormSelect>
                          </div>
                          <div className='mb-3'>
                            <CFormLabel htmlFor='exampleFormControlInput1'>
                              <strong>Terminal ID </strong>
                            </CFormLabel>
                            <CFormInput
                              type='text'
                              id='exampleFormControlInput1'
                              value={terminalId}
                              placeholder='Refer to Merchant receipt copy enter here '
                              onChange={(e) =>
                                this.setState({
                                  terminalId: e.target.value,
                                })
                              }
                            />
                          </div>
                          <div className='mb-3'>
                            <CFormLabel htmlFor='exampleFormControlInput1'>
                              <strong>Transaction Reference </strong>
                            </CFormLabel>
                            <CFormInput
                              type='text'
                              id='exampleFormControlInput1'
                              value={transactionReference}
                              placeholder='Refer to Merchant receipt copy enter here '
                              onChange={(e) =>
                                this.setState({
                                  transactionReference: e.target.value,
                                })
                              }
                            />
                          </div>
                          {/* usage */}
                          <div className='mb-3'>
                            <CRow>
                              <CCol md={4}>
                                <CFormLabel htmlFor='exampleFormControlInput1'>
                                  <strong>Usage </strong>
                                  <span className='required'>*</span>
                                </CFormLabel>
                              </CCol>
                              <CCol md={4}>
                                <div className='form-check'>
                                  <input
                                    className='form-check-input'
                                    type='radio'
                                    value='unlimited'
                                    id='usageUnlimited'
                                    name='usage'
                                    onChange={() => {
                                      this.setState({ usage: "unlimited" });
                                    }}
                                    checked={
                                      usage === "unlimited" ? true : false
                                    }
                                  />
                                  <label
                                    className='form-check-label'
                                    for='flexCheckDefault'
                                  >
                                    Unlimited
                                  </label>
                                </div>
                              </CCol>
                              <CCol md={4}>
                                <div className='form-check'>
                                  <input
                                    className='form-check-input'
                                    type='radio'
                                    value='limited'
                                    id='usageLimited'
                                    name='usage'
                                    onChange={() => {
                                      this.setState({ usage: "limited" });
                                    }}
                                    checked={usage === "limited" ? true : false}
                                  />
                                  <label
                                    className='form-check-label'
                                    for='flexCheckDefault'
                                  >
                                    Limited
                                  </label>
                                </div>
                              </CCol>
                            </CRow>
                          </div>
                          {usage && usage === "limited" && (
                            <div className='mb-3'>
                              <CFormLabel htmlFor='exampleFormControlInput1'>
                                <strong>Limit</strong>
                              </CFormLabel>
                              <CFormInput
                                type='number'
                                id='limit'
                                value={limit}
                                placeholder="Enter usage limit"
                                onChange={(e) =>
                                  this.setState({
                                    limit: e.target.value,
                                  })
                                }
                              />
                            </div>
                          )}
                        </>
                      )}
                    </CCol>
                  </CRow>
                </CCol>
              </CRow>
              <CRow>
                <CCol md={6}>
                  <div className='mb-3 mt-4'>
                    <CButton
                      type={loading ? "button" : "submit"}
                      style={{ width: "100%" }}
                      color='primary'
                      className='px-4'
                    >
                      {loading ? "Please Wait..." : "Generate"}
                    </CButton>
                  </div>
                </CCol>
                <CCol md={6}>
                  <div className='mb-3 mt-4'>
                    <CButton
                      type='button'
                      style={{ width: "100%", backgroundColor: "#999" }}
                      color='secondary'
                      className='px-4'
                      onClick={this.cancelForm}
                    >
                      Cancel
                    </CButton>
                  </div>
                </CCol>
              </CRow>
            </CForm>
          </CCardBody>
        </CCard>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  data: state.subscriptionAdmin,
  createBundleSuccess: state.coupon.createBundleSuccess,
  companyList: state.company.companyList,
});
export default connect(mapStateToProps, {
  getAllCompanies,
  generateCoupon,
})(CreateBundle);
